/* eslint-disable import/no-extraneous-dependencies -- for history. */
import { Transition, Location } from 'history';
import React, { useCallback, useEffect, useState } from 'react';

import { WarningModal } from './WarningModal';
import { useBlocker } from '../../hooks/useBlocker';

export type WarningModalProps = {
  when: boolean;
  title: string;
  cancelCaption: string;
  acceptCaption: string;
  onAccept?: (location: Location) => Promise<void>;
  onCancel?: () => void;
};

export const BlockingWarningModal: React.FC<React.PropsWithChildren<WarningModalProps>> = ({
  title,
  when,
  cancelCaption,
  acceptCaption,
  onAccept,
  onCancel,
  children,
}) => {
  const [blockingTransition, setBlockingTransition] = useState<Transition | undefined>(undefined);
  const [queryParamsBlockingTransition, setQueryParamsBlockingTransition] = useState<Transition | undefined>(undefined);
  const [internalWhen, setInternalWhen] = useState(true);

  useEffect(() => {
    setInternalWhen(!queryParamsBlockingTransition);
    if (!queryParamsBlockingTransition) {
      return;
    }

    queryParamsBlockingTransition.retry();
    setQueryParamsBlockingTransition(undefined);
  }, [queryParamsBlockingTransition]);

  useBlocker(setBlockingTransition, setQueryParamsBlockingTransition, internalWhen && when);

  const handleAccept = useCallback(async () => {
    if (!blockingTransition) {
      return;
    }

    setBlockingTransition(undefined);
    await onAccept?.(blockingTransition.location);

    blockingTransition.retry();
  }, [onAccept, blockingTransition]);

  const handleCancel = useCallback(() => {
    setBlockingTransition(undefined);
    onCancel?.();
  }, [onCancel]);

  return (
    <WarningModal
      isOpen={!!blockingTransition}
      title={title}
      cancelCaption={cancelCaption}
      acceptCaption={acceptCaption}
      onAccept={handleAccept}
      onCancel={handleCancel}
    >
      {children}
    </WarningModal>
  );
};
